import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { User } from '../../../models';
import { SecurityService, WorkflowContextService } from '../../../services';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators
} from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-user-search',
    templateUrl: './user-search.component.html',
    styleUrls: ['./user-search.component.css'],
    standalone: false
})
export class UserSearchComponent implements OnInit {
  @Output() searchStarted: EventEmitter<any> = new EventEmitter<any>();
  @Output() searchFinished: EventEmitter<User[]> = new EventEmitter<User[]>();
  // @Input() searchText: string;// commented this as I want to do searchChange and make it as a variable not as an input

      //added by priya 03-12-2025

  private _searchText: string = '';

  @Input()
  get searchText(): string {
    return this._searchText;
  }
  
  set searchText(value: string) {
    this._searchText = value ?? '';  
  }
  templateForPermitForm:boolean=false
//end by priya 03-12-2025

    form: UntypedFormGroup;
  constructor(
        public layoutService: LayoutService,
    private _securitySvc: SecurityService,
    private _context: WorkflowContextService,
    fb: UntypedFormBuilder,
    private _router: Router,
  ) {
    this.form = fb.group({ searchText: ['', Validators.nullValidator] });
    this.form.controls.searchText.valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        filter((query: string) => !query || query.length > 2)
      )
      .subscribe(a => {
        this.search();
      });

      //added by priya 2025-11-17
      const nav = this._router.getCurrentNavigation();
     layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
  
      //end by priya 2025-11-17
  }

  search() {
    if ((this.searchText || '') !== '') {
      this.searchStarted.next(null);
      this._securitySvc
        .searchUsers(this._context.client, { searchText: this.searchText })
        .subscribe(users => {
          this.searchFinished.next(users);
        });
    } else {
      this.searchFinished.next(null);
    }
  }

  ngOnInit() {
    if (this.searchText) {
      this.search();
    }
  }
    //added by priya 03-12-2025

  onSearchTextChange(val: string) {
  this.searchText = val;
  this.form.get('searchText')?.setValue(val, { emitEvent: true });
}
//end by priya 03-12-2025

  
}
